/**
 *
 *  RewardBadge -- as we use svg icons with masks and gradients,
 *  there should be unique ids, in case of multiple icons in the same page
 *  Component
 *
 *  Created by Vladimir Shishlyannikov on 28/02/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React, { useState } from "react";

import ReConditioningIcon from "../../../icons/ReConditioningIcon";
import ReHolisticHeroIcon from "../../../icons/ReHolisticHeroIcon";
import ReLifestyleSpecialistIcon from "../../../icons/ReLifestyleSpecialistIcon";
import ReSelfCareSpecialistIcon from "../../../icons/ReSelfCareSpecialistIcon";
import ReNewlyDiscoveredIcon from "../../../icons/ReNewlyDiscoveredIcon";
import ReTransformationSpecialistIcon from "../../../icons/ReTransformationSpecialistIcon";
import ReTopMotivatorIcon from "../../../icons/ReTopMotivatorIcon";
import ReZenMasterIcon from "../../../icons/ReZenMasterIcon";
import ReEnduranceIcon from "../../../icons/ReEnduranceIcon";
import ReMindfulnessIcon from "../../../icons/ReMindfulnessIcon";
import ReFlexibilityIcon from "../../../icons/ReFlexibilityIcon";
import ReLifestyleIcon from "../../../icons/ReLifestyleIcon";

import { uniqueId } from "../../../utils/_";
import { makeUrlString } from "../../../utils";

const rewardIconsMap = {
  conditioning: ReConditioningIcon,
  "self-care": ReSelfCareSpecialistIcon,
  "holistic-hero": ReHolisticHeroIcon,
  "zen-master": ReZenMasterIcon,
  "top-motivator": ReTopMotivatorIcon,
  "weight-loss": ReTransformationSpecialistIcon,
  endurance: ReEnduranceIcon,
  mindfulness: ReMindfulnessIcon,
  flexibility: ReFlexibilityIcon,
  nutrition: ReLifestyleSpecialistIcon,
  lifestyle: ReLifestyleIcon,
  // Deprecated
  "conditioning-specialist": ReConditioningIcon,
  "lifestyle-specialist": ReLifestyleIcon,
  "self-care-specialist": ReSelfCareSpecialistIcon,
  "transformation-specialist": ReTransformationSpecialistIcon,
};

export const RewardBadge = ({ label, size }) => {
  const [_id] = useState(`reward_icon_${uniqueId()}`);
  let RewardIcon = ReNewlyDiscoveredIcon;

  // Correct! JSX type can be a capitalized variable.
  if (label) {
    RewardIcon = rewardIconsMap[makeUrlString(label)];
  }

  if (!RewardIcon) {
    RewardIcon = ReNewlyDiscoveredIcon;
  }

  return (
    <div className="tb-badge-reward tbk-flex tbk-items-center tbk-px-0 tbk-py-0.5 lg:tbk-px-0">
      <RewardIcon id={_id} size={size} className="tbk-mr-1" />
      <div className="tbk-text-small lg:tbk-text-main tbk-whitespace-nowrap tbk-text-primary">
        {label || "Unspecified"}
      </div>
    </div>
  );
};

export default RewardBadge;
